import {type ComponentProps, useCallback} from 'react';

import {Tag} from '../input-tag/tag';

import {type ListBoxItem} from '../listbox/listbox.types';

import {useInputAutocompleteContext} from './input-autocompltete-context';

type Props = Omit<ComponentProps<typeof Tag>, 'selected' | 'onDelete' | 'onUnselect'> & {
    value: ListBoxItem['value'];
};

export const TagAutocompleteConnected = ({value, label, ...props}: Props) => {
    const {removeItem, unselectItem, selectedItem} = useInputAutocompleteContext();

    const handleDelete = useCallback(() => removeItem(value), [value, removeItem]);

    return (
        <Tag
            {...props}
            label={label}
            selected={selectedItem === label}
            onDelete={handleDelete}
            onUnselect={unselectItem}
        />
    );
};
